import {
    Create,
    required,
    SimpleForm,
    NullableBooleanInput,
    minValue,
    FormDataConsumer,
    DataProviderContext,
    useDataProvider,
    NumberInput,
} from 'react-admin';
import { useParams } from 'react-router';
import { LoadingSection } from '../../common/LoadingSection';
import { useNavigate } from 'react-router-dom';
import TotalAmountInput from '../../common/inputs/TotalAmountInput';
import DiscountInput from '../../common/DiscountInput';
import FileUpload from '../../common/inputs/FileUpload';
import React from 'react';
import { createCustomGoDataProvider } from '../../services';
import { useLocation } from "react-router-dom";

const NonCategoryProductCreate = () => {
    let { productTemplateId } = useParams();
    const location = useLocation();
    const type = location.state?.type;
    const typeId = location.state?.typeId;
    const parentData = location.state?.parentData;

    const navigate = useNavigate();
    if (!productTemplateId) {
        return <LoadingSection />;
    }

    // @ts-ignore
    const baseDataProvider = useDataProvider();
    const customDataProvider = React.useMemo(
        () =>
            createCustomGoDataProvider(baseDataProvider, [
                { resource: 'ecom_products', apiEndpoint: '/ecom/digital-products' },
            ]),
        [baseDataProvider],
    );
    return (
        <DataProviderContext.Provider value={customDataProvider}>
            <Create
                resource="ecom_products"
                redirect={false}
                mutationOptions={{
                    onSuccess: () => {
                        navigate(-1);
                    },
                }}
                transform={(data: any) => {
                    return {
                        ...data,
                        name: parentData?.name || parentData?.title,
                        textDescription: parentData?.description || parentData?.textDescription,
                        htmlDescription: parentData?.htmlDescription || parentData?.description,
                        amount: Number(data.amount),
                        type,
                        typeId
                    };
                }}

            >
                <SimpleForm >
                    <FileUpload
                        type="VIDEO_THUMBNAIL"
                        label="select images"
                        source="images"
                        accept="image/*"
                        multiple={true}
                    />
                    <FileUpload
                        type="PDF_NOTES"
                        source="previewPdf"
                        label="select preview pdf"
                        accept="application/pdf"
                        multiple={false}
                    />
                    <NullableBooleanInput
                        source={'addressRequired'}
                        fullWidth={true}
                        name={'Address Required'}
                    />
                    <NumberInput
                        type={'number'}
                        source="mrp"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <DiscountInput />
                    <NumberInput
                        type={'number'}
                        source="gstPercentage"
                        prefix={'%'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <FormDataConsumer>
                        {({ formData, ...rest }) => {
                            return (
                                <div className="w-full">
                                    <TotalAmountInput formData={formData} source="amount" />
                                </div>
                            );
                        }}
                    </FormDataConsumer>
                    <NumberInput
                        type={'number'}
                        source="appleAmount"
                        prefix={'₹'}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                    <NumberInput
                        type={'number'}
                        source="validityInDays"
                        defaultValue={0}
                        fullWidth
                        validate={[required(), minValue(0)]}
                    />
                </SimpleForm>
            </Create>
        </DataProviderContext.Provider>
    );
};

export default NonCategoryProductCreate;
